// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    INNOVATION_BY_DESIGN_PAGE_LOADING() {
      return {
        isLoading: true,
        innovationByDesignPage: action.innovationByDesignPage
      };
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'innovation-by-design',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'innovation/innovation-by-design';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    INNOVATION_BY_DESIGN_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
